import type { FaireProductEntity } from "../../entity_types/product";

export const oskro_1: FaireProductEntity = {
  token: "oskro-1",
  type: "product",
  name: "Creamy Pistachio Spread",
  brandName: "Oskrö",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/92f1720de98adede92a4e1ce7abff38652be4359bc4363a724996e08cb676bc0.webp",
  priceDollars: 14.5,
  msrpDollars: 24,
  freeShipping: true,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
